import { FACEBOOK_PIXEL_ID, USER_KEY, GRAND_TOTAL_KEY } from "../Constant";

/* ------------------ Helpers ------------------ */

const safeFbq = (...args) => {
    if (typeof window.fbq === "function") {
        window.fbq(...args);
    }
};

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
};

const generateEventId = (prefix = "evt") => {
    return `${prefix}_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
};

const normalizeEmail = (email) => {
    return email?.trim().toLowerCase();
};

const normalizePhone = (phone) => {
    return phone?.replace(/\D/g, "");
};

export const initPixel = (user) => {
    const userData = {};
    if (user?.email) {
        userData.em = normalizeEmail(user.email);
    }
    if (user?.first_name) {
        userData.fn = user.first_name.trim().toLowerCase();
    }
    if (user?.mobile_number) {
        userData.ph = normalizePhone(user.mobile_number);
    }
    if (user?.customer_id) {
        userData.external_id = user.customer_id.toString();
    }
    else{
        userData.external_id = localStorage.getItem('token') || "";
    }

    safeFbq("init", FACEBOOK_PIXEL_ID, userData);
};

const baseUserParams = (user) => {
    const params = {
        fbp: getCookie("_fbp"),
        fbc: getCookie("_fbc")
    };
    if (user?.customer_id) {
        params.external_id = user.customer_id.toString();
    }
    else {
        params.external_id = localStorage.getItem('token') || "";
    }

    return params;
};

/* ------------------ Checkout ------------------ */

export const checkoutEventsFB = (data) => {

    let user = localStorage.getItem(USER_KEY);
    user = user ? JSON.parse(user) : null;

    const products = data?.products?.map(product => ({
        content_brand: product?.designer_name,
        content_name: product?.title,
        content_category: product?.category_name,
        id: [product?.sku],
    })) || [];

    let totalValue = data?.totals?.filter(x => x.name === GRAND_TOTAL_KEY)[0]?.value || "";
    totalValue = totalValue.replace("₹", "");
    totalValue = totalValue.replace(/,/g, '');

    safeFbq("track", "PageView", {
        ...baseUserParams(user),
        customer_Ids: user?.customer_id ? [user.customer_id] : [],
        membership_type: user ? "Yes" : "Guest user",
        total_order: user ? user.total_order : 0,
        value: totalValue,
        currency: "INR",
        event_id: data?.pageview_event_id || generateEventId("page_view")
    });

    safeFbq("track", "InitiateCheckout", {
        ...baseUserParams(user),
        contents: products,
        content_type: "product_group",
        value: totalValue,
        currency: "INR",
        event_id: data?.initiatecheckout_event_id || generateEventId("initiate_checkout")
    });
};

/* ------------------ Product Page ------------------ */

export const productPageEventsFB = (data) => {

    let user = localStorage.getItem(USER_KEY);
    user = user ? JSON.parse(user) : null;

    const sku = data?.product?.product_info;
    let totalValue = data?.product?.discount_price || "";
    totalValue = totalValue.replace("₹", "");
    totalValue = totalValue.replace(/,/g, '');
    totalValue = parseInt(totalValue);


    safeFbq("track", "PageView", {
    ...baseUserParams(user),
    customer_Ids: user?.customer_id ? [user.customer_id] : [],
    membership_type: user ? "Yes" : "Guest user",
    total_order: user ? user.total_order : 0,
    value: totalValue,
    currency: "INR",
    event_id: data?.pageview_event_id || generateEventId("page_view")
    });


    safeFbq("track", "ViewContent", {
        ...baseUserParams(user),
        content_brand: data?.product?.designer_name,
        content_name: data?.product?.name,
        content_ids: [sku[0]?.value],
        content_type: "product_group",
        value: totalValue,
        currency: "INR",
        event_id: data?.viewcontent_event_id || generateEventId("view_content")
    });

    // adroll code
    try {
        if (user) {
            window.adroll.track('productView', { "products": [{ "product_id": sku[0]?.value }] });
            window.__adroll.record_user(window.adroll_custom_data = { "customer_type": "Yes", "customer_id": user?.customer_id, "telephone": user.mobile_number ? user.mobile_number : "", "page_type": "Product" });
        } else {
            window.adroll.track('productView', { "products": [{ "product_id": sku[0]?.value }] });
            window.__adroll.record_user(window.adroll_custom_data = { "customer_type": "Guest user", "page_type": "Product" });
        }
    } catch (e) {
        // adroll not loaded
    }
};

/* ------------------ Add To Cart ------------------ */

export const addToCartEventsFB = (product, cartProduct, event_id) => {

    let user = localStorage.getItem(USER_KEY);
    user = user ? JSON.parse(user) : null;

    const productDetails = product?.options?.[0]?.items?.find(x => x.id === cartProduct?.value);
    const sku = productDetails?.sku !== "" ? productDetails?.sku : product?.product_info?.[0]?.value;

    let totalValue = product?.discount_price || "";
    totalValue = totalValue.replace("₹", "");
    totalValue = totalValue.replace(/,/g, '');

    safeFbq("track", "AddToCart", {
        ...baseUserParams(user),
        content_brand: product?.designer_name,
        content_name: product?.name,
        content_ids: [sku],
        content_type: "product_group",
        value: totalValue,
        currency: "INR",
        event_id: event_id || generateEventId("add_to_cart")
    });
};

/* ------------------ Wishlist ------------------ */

export const addToWishlistEventsFB = (data) => {

    let user = localStorage.getItem(USER_KEY);
    user = user ? JSON.parse(user) : null;

    const contents = data?.wishlist_products?.map(product => {
        let totalValue = product.discount_price || "";
        totalValue = totalValue.replace("₹", "");
        totalValue = totalValue.replace(/,/g, '');
        return {
            content_brand: product.designer_name,
            content_name: product.title,
            id: [product.product_id],
            value: totalValue,
            currency: "INR",
        };
    }) || [];
   
    safeFbq("track", "PageView", {
        ...baseUserParams(user),
        customer_Ids: user?.customer_id ? [user.customer_id] : [],
        membership_type: user ? "Yes" : "Guest user",
        total_order: user ? user.total_order : 0,
        value: contents?.value  || 0,
        currency: "INR",
        event_id: data?.pageview_event_id || generateEventId("page_view")
    });

    safeFbq("track", "AddToWishlist", {
        ...baseUserParams(user),
        contents: contents,
        content_type: "product_group",
        currency: "INR",
        event_id: data?.addtowishlist_event_id || generateEventId("add_to_wishlist")
    });
};

/* ------------------ Category / Search ------------------ */

export const categoryPageEventsFB = (data, searchTerm) => {

    let user = localStorage.getItem(USER_KEY);
    user = user ? JSON.parse(user) : null;

    safeFbq("track", "PageView", {
    ...baseUserParams(user),
    customer_Ids: user?.customer_id ? [user.customer_id] : [],
    membership_type: user ? "Yes" : "Guest user",
    total_order: user ? user.total_order : 0,
    currency: "INR",
    event_id: data?.pageview_event_id || generateEventId("page_view")
    });

    if (searchTerm) {
        safeFbq("track", "Search", {
            ...baseUserParams(user),
            search_string: searchTerm,
            content_ids: [],
            content_type: "product",
            event_id: data?.search_event_id || generateEventId("search")
        });
    } else {
        safeFbq("trackCustom", "ViewCategory", {
            ...baseUserParams(user),
            content_category: data?.fproducts?.category_name || "",
            event_id: data?.viewcategory_event_id || generateEventId("view_category")
        });
    }
};

/* ------------------ Purchase ------------------ */

export const onPurchaseEventsFB = (data, productsIds, receipt_created = "") => {

    let user = localStorage.getItem(USER_KEY);
    user = user ? JSON.parse(user) : null;

    let totalValue = data?.order_total || "";
    totalValue = totalValue.replace("₹", "");
    totalValue = totalValue.replace(/,/g, '');

    let payment_mode = "";
    if (data?.payment_mode && data?.payment_mode === "COD") {
            payment_mode = "COD Pending";
    } else {
        if (data?.payment_status && data?.payment_status === "pending") {
            payment_mode = "Prepaid Pending";
        } else {
            payment_mode = "Prepaid Success";
        }
    }

    safeFbq("track", "PageView", {
    ...baseUserParams(user),
    customer_Ids: user?.customer_id ? [user.customer_id] : [],
    membership_type: user ? "Yes" : "Guest user",
    total_order: user ? user.total_order : 0,
    value: totalValue,
    currency: "INR",
    event_id: data.order_number ? "event.id.pageview.purchase." + data.order_number : ""
    });

    safeFbq("track", "Purchase", {
        ...baseUserParams(user),
        content_ids: productsIds,
        content_type: "product_group",
        value: totalValue,
        currency: "INR",
        transaction_ids: data.order_number,
        payment_type: payment_mode,
        event_id: data.order_number ? "event.id.purchase." + data.order_number : ""
    });


    // adroll code
    try {
        window.adroll.track("pageView", {
            "order_id": data?.order_number,
            "conversion_value": parseInt(totalValue),
            "currency": "INR"
        });
        window.__adroll.record_user(window.adroll_custom_data = { "payment_type": payment_mode });
    } catch (e) {
        // adroll not loaded
    }
};

/* ------------------ Common Page ------------------ */

export const commonPageEventsFB = (page_type) => {

    let user = localStorage.getItem(USER_KEY);
    user = user ? JSON.parse(user) : null;

    const eventId = generateEventId("page_view");

    safeFbq("track", "PageView", {
        ...baseUserParams(user),
        currency: "INR",
        page_type: page_type,
        membership_type: user ? "Yes" : "Guest user",
        total_order: user ? user.total_order : 0,
        event_id: eventId
    });
};
